var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"warnBlock",style:({ margin: _vm.margin })},[_c('svg-sprite',{style:(`color: ${_vm.getColor}`),attrs:{"height":"20","width":"20","icon-id":"warn"}}),_c('span',{staticClass:"warnBlock_text",class:{'redText': _vm.isRed, 'orangeText': _vm.isOrange}},[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }